import { useEffect, useState } from 'react'

import { Box, type SortDirection, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'

import { codesFormFactory } from 'modules/payroll_integrations/components/Form'
import type { Codeable, ColumnNames } from 'modules/payroll_integrations/lib/types'

import type CodeForm from '../Form/form'
import Body from './_Body'
import Header from './_Header'
import FilterBox from './_SearchBar'
import { filterItems, loadCodes, orderItems, searchItems } from './_Utils'

const defaultOrder = 'asc'
const defaultSortedColumn = 'concept'
interface BodyProps {
  columnNames: ColumnNames
  codeables: Record<string, Codeable>
  integration: string
}

const CodeTable = ({ codeables, columnNames, integration }: BodyProps) => {
  const [filter, setFilter] = useState('')
  const [forms, setForms] = useState<CodeForm[]>([])
  const [filteredForms, setFilteredForms] = useState<any>([])
  const [direction, setDirection] = useState<SortDirection>(defaultOrder)
  const [attribute, setAttribute] = useState<string>(defaultSortedColumn)
  const { search, onSearch, debouncedSearch } = useDebouncedSearch()

  useEffect(() => {
    const builder = async () => {
      await loadCodes(integration)

      const codeForms = await codesFormFactory(codeables, integration)

      setForms(codeForms)
    }

    builder()
  }, [codeables, integration])

  useEffect(() => {
    const searchedForms = filterItems(searchItems(forms, debouncedSearch), filter)
    const orderedForms = orderItems(searchedForms, attribute, direction)
    setFilteredForms(orderedForms)
  }, [forms, debouncedSearch, filter, attribute, direction])

  const onSort = (attribute: string, direction: SortDirection) => {
    setDirection(direction)
    setAttribute(attribute)
  }

  const onChangeFilter = (type: string) => {
    setFilter(type)
  }

  const filterOptions = []
  for (const key in codeables) {
    const codeable = codeables[key]
    if (codeable) {
      filterOptions.push({
        label: codeable.label,
        value: codeable.class,
      })
    }
  }

  return (
    <BoxList>
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        width="full"
        background="grey200"
        padding="s16"
      >
        <Box width="full">
          <FilterBox
            onChangeFilter={onChangeFilter}
            search={search}
            onSearch={onSearch}
            filter={filter}
            options={filterOptions}
          />
        </Box>
      </Box>

      <Table noRadius hideBorder>
        <Header
          columnNames={columnNames}
          onSort={onSort}
          attribute={attribute}
          direction={direction}
        />
        <Body forms={filteredForms} options={[]} />
      </Table>
    </BoxList>
  )
}

export default observer(CodeTable)
